import React, { useEffect, useRef } from "react";
import { Box, Text } from "@radix-ui/themes";
import styles from "./styles.module.scss";
import Button from "../Button";
import { animateBanner } from "../../../utils/animations";

const Banner = ({ image }) => {
  const bannerRef = useRef(null);
  const wordRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    return animateBanner(bannerRef, wordRef, buttonRef);
  }, []);

  return (
    <Box ref={bannerRef} className={styles["banner"]}>
      <img src={image} alt="Renova Banner" className={styles["banner-image"]} />
      <Text ref={wordRef} className={styles["banner-text"]}>
        RENOVATE. REGENERATE. REVITALIZE.
      </Text>
      <Button 
        ref={buttonRef} 
        className={styles["banner-button"]} 
        size="4" 
        variant="outlined"
        backgroundColor="var(--color-primary)"
        textColor="var(--color-secondary)"
        onClick={() => {
          window.location.href = "/services";
        }}
      >
        Explore Services
      </Button>
    </Box>
  );
};

export default Banner;
